import React, { ChangeEvent, useEffect, useState } from "react";
import DashboardLayout from "../../../Layout/DashboardLayout";
import { useParams } from "react-router-dom";
import { useGetSingleDiscountQuery } from "hooks/DiscountManagement/useGetSingleDiscountQuery";
import Back from "Components/Back";
import Scaffold from "Components/Scaffold";
import OrderDiscountForm from "./Forms/OrderDiscountForm";
import CustomerDiscountForm from "./Forms/CustomerDiscountForm";
import Loader from "Components/Loader";
import ProductDiscountForm from "./Edits/ProductDiscountForm";

const EditDiscountManagement = () => {
  const { id } = useParams();

  const {
    data: discount,
    isPending,
    isError,
  } = useGetSingleDiscountQuery(`${id}`);

  const data = discount?.data;
  const [payload, setPayload] = useState(discount?.data);
  const [startDate, setStartDate] = useState(data?.startDate);
  const [endDate, setEndDate] = useState("");
  const handleInputChange = (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;
    setPayload((prev: any) => ({ ...prev, [name]: value }));
  };

  useEffect(() => {
    setPayload(discount?.data);
    setStartDate(discount?.startDate);
    setEndDate(discount?.endDate);
  }, [discount?.data, discount?.endDate, discount?.startDate]);

  return (
    <DashboardLayout title="Edit Discount Details">
      <div className="px-4 mt-5">
        <Back />
        <div className="max-w-[486px] mx-auto mt-[30px] border-[1px] border-[#eeeeee] rounded-[10px]">
          {isPending && <Loader />}
          {payload && (
            <Scaffold left="Create Coupon">
              <div className="border-t-[#eeeeee] border-r-[#fff] border-l-[#fff] border-[1px] border-b-[#eeeeee] px-[20px] py-[10px] text-[#a8a8a8]">
                Select Coupon Type
              </div>

              <>
                <div className="px-[20px]">
                  <select
                    name="discountType"
                    onChange={handleInputChange}
                    className="p-[10px] border-[1px] border-[#d3d3d3] my-[10px] w-full rounded-md"
                    value={payload.discountType}
                  >
                    <option value="" disabled>
                      --Select Option--
                    </option>
                    <option value="order">Order</option>
                    <option value="product">Product</option>
                    <option value="customer">Customer</option>
                  </select>
                </div>

                <div className="px-[20px]">
                  {/* {payload?.discountType === "order" && (
                    <OrderDiscountForm
                      payload={payload}
                      setPayload={setPayload}
                      startDate={startDate}
                      setStartDate={setStartDate}
                      endDate={endDate}
                      setEndDate={setEndDate}
                      handleInputChange={handleInputChange}
                    />
                  )}
                  {payload?.discountType === "customer" && (
                    <CustomerDiscountForm />
                  )} */}
                  {payload?.discountType === "product" && (
                    <ProductDiscountForm />
                  )}
                </div>
              </>
            </Scaffold>
          )}
        </div>
      </div>
    </DashboardLayout>
  );
};

export default EditDiscountManagement;
